export default "__VITE_ASSET__ab227270__"